import { declareParams, concurrency } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createQuery } from '../clients';
import { betHistorySchema } from '../types';

export type GetBetHistoryQueryParams = {
	page: number;
	limit: number;
};

export const getBetHistoryQuery = createQuery({
	params: declareParams<GetBetHistoryQueryParams>(),
	request: {
		method: 'GET',
		url: '/rounds/my',
		query: (params) => params,
	},
	response: {
		contract: zodContract(betHistorySchema),
	},
});

concurrency(getBetHistoryQuery, { strategy: 'TAKE_LATEST' });
